import classNames from "classnames";
import { useNavigate, type NavLinkProps } from "react-router-dom";
import { AppNavLink } from "@/shared/Components";
import { useBlockingModal, useInvalidContactModal } from "@/services/blocking-modal";
import { updateIsLoadingSelector } from "@/pages/ContactsPage/slice";
import type { FC } from "react";
import styles from "./styles.module.scss";

type Props = NavLinkProps & {
  title: string;
};

export const HeaderNavLink: FC<Props> = ({ title, ...props }) => {
  const navigate = useNavigate();
  const { executeWithModal } = useBlockingModal(updateIsLoadingSelector);
  const { executeWithConfirm } = useInvalidContactModal();

  const confirmAction = executeWithConfirm(() => navigate(props.to ?? "/"));

  const handleClick = (event: React.MouseEvent) => {
    event.preventDefault();

    executeWithModal(() => {
      confirmAction();
    });
  };

  return (
    <AppNavLink className={styles["link-container"]} {...props}>
      {({ isActive }) => {
        return (
          <div
            className={classNames(styles.link, { [styles.active]: isActive })}
            onClick={handleClick}
          >
            {title}
          </div>
        );
      }}
    </AppNavLink>
  );
};
